<template>
    <div class="error-notification">{{ message }}</div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    message: { type: String, required: true }
});
</script>

<style lang="scss" scoped>
.error-notification {
    color: var(--color-red);
    font-size: 12px;
    text-align: center;
    padding: 5px;
    background-color: rgba(255, 0, 0, 0.1);
    border-radius: 4px;
    align-self: center;
    width: 90%;
}
</style>
